import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Header() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const onLogout = () => {
    logout();
    nav("/");
  };

  return (
    <header style={{ borderBottom: "1px solid var(--border)", background: "rgba(10,10,11,0.85)", backdropFilter: "blur(12px)", position: "sticky", top: 0, zIndex: 50 }}>
      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "16px 24px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Link to="/" data-testid="header-logo" style={{ textDecoration: "none", display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontSize: 22, color: "var(--gold)" }}>✦</span>
          <span className="serif" style={{ fontSize: 22, color: "#fff", letterSpacing: "0.04em" }}>Obituary Relief</span>
        </Link>
        <nav style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {user ? (
            <>
              <Link to="/dashboard" data-testid="nav-dashboard" className="btn-ghost" style={{ textDecoration: "none", fontSize: 14 }}>Dashboard</Link>
              <Link to="/team" data-testid="nav-team" className="btn-ghost" style={{ textDecoration: "none", fontSize: 14 }}>Team</Link>
              <Link to="/grief-support" data-testid="nav-grief" className="btn-ghost" style={{ textDecoration: "none", fontSize: 14 }}>Grief Support</Link>
              <Link to="/profile" data-testid="nav-profile" className="btn-ghost" style={{ textDecoration: "none", fontSize: 14 }}>Profile</Link>
              <Link to="/new" data-testid="nav-new" className="btn-gold" style={{ textDecoration: "none", fontSize: 14 }}>New Obituary</Link>
              {user.is_owner && (
                <Link to="/owner" data-testid="nav-owner" className="btn-ghost" style={{ textDecoration: "none", fontSize: 14 }}>Admin</Link>
              )}
              <button onClick={onLogout} data-testid="nav-logout" className="btn-ghost" style={{ fontSize: 14 }}>Log out</button>
            </>
          ) : (
            <>
              <Link to="/grief-support" data-testid="nav-grief-public" className="btn-ghost" style={{ textDecoration: "none", fontSize: 14 }}>Grief Support</Link>
              {loc.pathname !== "/login" && (
                <Link to="/login" data-testid="nav-login" className="btn-ghost" style={{ textDecoration: "none", fontSize: 14 }}>Log in</Link>
              )}
              {loc.pathname !== "/signup" && (
                <Link to="/signup" data-testid="nav-signup" className="btn-gold" style={{ textDecoration: "none", fontSize: 14 }}>Get Started</Link>
              )}
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
